/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { CircularProgress, TablePagination, Tooltip } from "@mui/material";
import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useListarProdutosV1 } from "services/api/Mobile_ProdutosV1/produtosv1";
import { FooterTable, PaginationInterfaceSend } from "components/FooterTable";
import DialogCommon from "components/dialogCommon";
import ModalCommon from "components/ModalCommon";
import { CARGO_CODES } from "constants/permissions";
import { Context } from "../../context/Context";

import * as IconsSVG from "../../assets/iconsSVG";
import NavCommon from "../../components/@navHeader";
import { AuthState } from "../../store/ducks/auth/types";
import FiltersContent from "./components/filtersContent";
import ProductCard from "./components/productCard";
import SkeletonGrid from "./components/skeletonGrid";
import * as Styles from "./styles";
import ModalEspelho from "./components/modalEspelho";
import ModalResumo from "./components/modalResumo";
import variavel from "../../enviroments";

interface Product {
  idEmpreendimento: string;
  nomeEmpreendimento: string;
  nomeBandeira: string;
  urlImagemPrincipal: string;
  statusEmpreendimento: string;
  quantidadeQuartos: string;
  metragemEmpreendimento: string;
  vagasGaragem: string;
  quantidadeDisponivel: number;
}

export default function Products() {
  const history = useHistory();
  const { idCorretor2013, codigoCargo2013 } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const [filtersCount, setFiltersCount] = useState<number>(0);
  const [filtersOpen, setFiltersOpen] = useState<boolean>(false);
  const { productsFilters, setProductsFilters } = useContext(Context);
  const [productsFiltersQuery, setProductsFiltersQuery] = React.useState("");
  const [clearFilters, setClearFilters] = React.useState(false);
  const [palavrasChave, setPalavrasChave] = React.useState("");
  const [inputBusca, setInputBusca] = React.useState("");
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const MIN_CHARS_BUSCA = 3;
  const DEBOUNCE_MS = 500;
  const [footerParams, setFooterParams] =
    React.useState<PaginationInterfaceSend>({
      PaginaAtual: 1,
      TotalItensRetorno: 9,
    });

  const Supervisor = codigoCargo2013 === CARGO_CODES.SUPERVISOR;

  const [oportunityModal, setOportunityModal] = useState<boolean>(false);
  const [resumoModal, setResumoModal] = useState<boolean>(false);
  const typeAmbiente = () => {
    if (variavel.AMBIENTE === "PROD") {
      return "https://admin.sellit.app.br/produtos";
    }
    if (variavel.AMBIENTE === "QA") {
      return "https://admin-qa.sellit.app.br/produtos";
    }
    if (variavel.AMBIENTE === "DEV") {
      return "https://admin-pre-prod.sellit.app.br/produtos";
    }
    return "";
  };

  // const handleChange = (e: any) => {
  //   setFieldBusca(e.target.value);
  //   const results = products?.filter((product: any) => {
  //     if (e.target.value === "") {
  //       setIsFiltered(false);
  //     } else {
  //       setIsFiltered(true);
  //     }
  //     return product.nomeEmpreendimento
  //       .toLowerCase()
  //       .includes(e.target.value.toLowerCase());
  //   });
  //   setFilteredProducts(results);
  // };

  const handleSearchChange = useCallback((value: string) => {
    setInputBusca(value);

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    if (value.length >= MIN_CHARS_BUSCA) {
      debounceTimerRef.current = setTimeout(() => {
        setPalavrasChave(value);
      }, DEBOUNCE_MS);
    } else if (value.length === 0) {
      setPalavrasChave("");
    }
  }, []);

  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const handleDrawerOpen = () => {
    setFiltersOpen(true);
  };

  const handleDrawerClose = () => {
    setFiltersOpen(false);
  };

  function replaceAll(string: string, search: string, replace: string) {
    return string.split(search).join(replace);
  }

  const handleFilters = (productFilters: any) => {
    const filterData: string[] = [];

    if (productFilters.OrdenarPorRecentes !== null) {
      const isRecent = productFilters.OrdenarPorRecentes === "recentes";
      filterData.push(replaceAll(`OrdenarPorRecentes=${isRecent}`, " ", ""));
    }
    if (productFilters.Status && productFilters.Status.length > 0) {
      productFilters.Status.forEach((item: any) =>
        filterData.push(replaceAll(`Status=${item}`, " ", ""))
      );
    }
    if (productFilters.Bandeiras && productFilters.Bandeiras.length > 0) {
      productFilters.Bandeiras.forEach((item: any) =>
        filterData.push(replaceAll(`Bandeiras=${item}`, " ", ""))
      );
    }
    if (productFilters.Tipos && productFilters.Tipos.length > 0) {
      productFilters.Tipos.forEach((item: any) =>
        filterData.push(replaceAll(`Tipos=${item}`, " ", ""))
      );
    }
    if (
      productFilters.QuantidadeDormitorios &&
      productFilters.QuantidadeDormitorios.length > 0
    ) {
      productFilters.QuantidadeDormitorios.forEach((item: any) =>
        filterData.push(replaceAll(`QuantidadeDormitorios=${item}`, " ", ""))
      );
    }
    if (
      productFilters.QuantidadeVagas &&
      productFilters.QuantidadeVagas.length > 0
    ) {
      productFilters.QuantidadeVagas.forEach((item: any) =>
        filterData.push(replaceAll(`QuantidadeVagas=${item}`, " ", ""))
      );
    }
    if (
      productFilters.InicioIntervaloValorImovel !== null &&
      productFilters.FimIntervaloValorImovel !== null
    ) {
      if (productFilters.InicioIntervaloValorImovel) {
        filterData.push(
          `InicioIntervaloValorImovel=${productFilters.InicioIntervaloValorImovel}`
        );
      }
      if (productFilters.FimIntervaloValorImovel) {
        filterData.push(
          `FimIntervaloValorImovel=${productFilters.FimIntervaloValorImovel}`
        );
      }
    }
    if (
      productFilters.InicioIntervaloMetragemImovel !== null &&
      productFilters.FimIntervaloMetragemImovel !== null
    ) {
      if (productFilters.InicioIntervaloMetragemImovel) {
        filterData.push(
          `InicioIntervaloMetragemImovel=${productFilters.InicioIntervaloMetragemImovel}`
        );
      }
      if (productFilters.FimIntervaloMetragemImovel) {
        filterData.push(
          `FimIntervaloMetragemImovel=${productFilters.FimIntervaloMetragemImovel}`
        );
      }
    }
    if (productFilters.Zonas && productFilters.Zonas.length > 0) {
      productFilters.Zonas.forEach((item: any) =>
        filterData.push(replaceAll(`Zonas=${item.value}`, " ", ""))
      );
    }
    if (productFilters?.IdBairro) {
      filterData.push(
        replaceAll(`IdBairro=${productFilters?.IdBairro?.value}`, " ", "")
      );
    }

    setFiltersCount(filterData.length);

    return `&${replaceAll(filterData.toString(), ",", "&")}`;
  };

  const {
    data: dataProdutosV1,
    refetch: refetchProdutosV1,
    isLoading,
    isFetching,
  } = useListarProdutosV1({
    PalavrasChave: palavrasChave,
    filtersQuery: productsFiltersQuery,
    PaginaAtual: footerParams.PaginaAtual,
    TotalItensRetorno: footerParams.TotalItensRetorno,
    queryKey: "listar_produtos",
  });

  const hasLoadedProductsData = Array.isArray(dataProdutosV1?.data);
  const isInitialLoading = (isLoading || isFetching) && !hasLoadedProductsData;
  const isRefreshingResults = isFetching && hasLoadedProductsData;

  React.useEffect(() => {
    refetchProdutosV1();
  }, [palavrasChave]);

  React.useEffect(() => {
    if (!isFetching) {
      refetchProdutosV1();
    }
  }, [footerParams]);

  React.useEffect(() => {
    // setProductsFilters(handleFilters(productsFilters));
    setProductsFiltersQuery(handleFilters(productsFilters));
    // console.log("-->", handleFilters(productsFilters));
    setClearFilters(false);
  }, [productsFilters]);

  React.useEffect(() => {
    if (productsFiltersQuery) {
      refetchProdutosV1();
    }
  }, [productsFiltersQuery]);

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: "", name: "Produtos" }]}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => {}}
      />
      <Styles.ProductsContainer>
        <Styles.PageTitle>Produtos</Styles.PageTitle>
        <Styles.PageSubtitle>
          Procure pelos produtos que mais se adequem aos seus leads
        </Styles.PageSubtitle>
        <Styles.ProductsContent>
          <>
            <Styles.HeaderContent>
              <Styles.FieldBusca
                value={inputBusca}
                onChange={(event) => handleSearchChange(event.target.value)}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    if (debounceTimerRef.current) {
                      clearTimeout(debounceTimerRef.current);
                    }
                    setPalavrasChave(inputBusca);
                    ev.preventDefault();
                  }
                }}
                placeholder="Buscar produtos"
                variant="outlined"
                color="secondary"
                size="small"
                InputProps={{
                  startAdornment: (
                    <Styles.InputAdornment position="start">
                      <Styles.IconButton
                        aria-label="Buscar Produtos"
                        onClick={() => {
                          if (debounceTimerRef.current) {
                            clearTimeout(debounceTimerRef.current);
                          }
                          setPalavrasChave(inputBusca);
                        }}
                      >
                        {isRefreshingResults ? (
                          <CircularProgress
                            size={18}
                            style={{ color: "#424248" }}
                          />
                        ) : (
                          <IconsSVG.SearchIconWhite />
                        )}
                      </Styles.IconButton>
                    </Styles.InputAdornment>
                  ),
                }}
              />
              {Supervisor && (
                <Styles.BtnLink
                  onClick={() => {
                    window.open(typeAmbiente(), "_blank");
                  }}
                >
                  Gerenciar produtos{" "}
                  <div className="link-icon">
                    <IconsSVG.ProductPredio2 color="#fff" />
                  </div>
                </Styles.BtnLink>
              )}
              <Styles.BtnEV
                onClick={() => {
                  setOportunityModal(true);
                }}
              >
                Espelho de vendas{" "}
                <IconsSVG.ExternalLinkWhite className="link-icon" />
              </Styles.BtnEV>
              <Styles.BtnEV
                onClick={() => {
                  setResumoModal(true);
                }}
              >
                Resumo <IconsSVG.ExternalLinkWhite className="link-icon" />
              </Styles.BtnEV>
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <Tooltip
                  followCursor
                  title="Limpar e Atualizar"
                  placement="top"
                  arrow
                >
                  <Styles.OnPress
                    onClick={() => {
                      setClearFilters(true);
                      setProductsFilters({
                        OrdenarPorRecentes: null,
                        InicioIntervaloMetragemImovel: null,
                        FimIntervaloMetragemImovel: null,
                      });
                    }}
                  >
                    <IconsSVG.ReloadFiltersIcon />
                    {filtersCount > 0 && (
                      <Styles.FiltersCount>{filtersCount}</Styles.FiltersCount>
                    )}
                  </Styles.OnPress>
                </Tooltip>
                <Tooltip followCursor title="Filtrar" placement="top" arrow>
                  <Styles.OnPress onClick={() => setFiltersOpen(!filtersOpen)}>
                    <IconsSVG.FilterIcon />
                  </Styles.OnPress>
                </Tooltip>
              </div>
            </Styles.HeaderContent>

            {isInitialLoading ? (
              <SkeletonGrid />
            ) : (
              <Styles.ProductsListContainer isRefreshing={isRefreshingResults}>
                <Styles.ProductsList>
                  {dataProdutosV1?.data?.length <= 0 ? (
                    <Styles.NotFoundText>
                      Nenhum produto encontrado
                    </Styles.NotFoundText>
                  ) : (
                    dataProdutosV1?.data?.map((product: Product) => {
                      return (
                        <ProductCard
                          key={product.idEmpreendimento}
                          idEmpreendimento={product?.idEmpreendimento}
                          nomeEmpreendimento={product?.nomeEmpreendimento}
                          nomeBandeira={product?.nomeBandeira}
                          urlImagemPrincipal={product?.urlImagemPrincipal}
                          statusEmpreendimento={product?.statusEmpreendimento}
                          quantidadeQuartos={product?.quantidadeQuartos}
                          metragemEmpreendimento={
                            product?.metragemEmpreendimento
                          }
                          vagasGaragem={product?.vagasGaragem}
                          quantidadeDisponivel={product?.quantidadeDisponivel}
                        />
                      );
                    })
                  )}
                </Styles.ProductsList>
              </Styles.ProductsListContainer>
            )}
          </>
        </Styles.ProductsContent>
        <FooterTable
          onData={(data: PaginationInterfaceSend) => {
            setFooterParams({
              PaginaAtual: data?.PaginaAtual,
              TotalItensRetorno: data?.TotalItensRetorno,
            });
          }}
          isLoading={isInitialLoading}
          countTotalPagination={dataProdutosV1?.pagination?.quantityPages}
          PaginaAtual={footerParams?.PaginaAtual}
          TotalItensRetorno={footerParams?.TotalItensRetorno}
        />
      </Styles.ProductsContainer>
      <Styles.SwipeableDrawer
        open={filtersOpen}
        anchor="right"
        onClose={handleDrawerClose}
        onOpen={handleDrawerOpen}
      >
        <FiltersContent
          onCloseModal={() => setFiltersOpen(false)}
          clearFilter={clearFilters}
        />
      </Styles.SwipeableDrawer>
      <DialogCommon
        closeText=""
        saveText=""
        onClose={() => setOportunityModal(false)}
        onSave={() => {}}
        titleHeader="Qual bloco você gostaria de ver?"
        isRight={false}
        onClean={() => {}}
        isFilter={false}
        isClose
        width={600}
        marginBottom={54}
        component={<ModalEspelho idCorretor2013={idCorretor2013} />}
        setOpenModal={setOportunityModal}
        open={oportunityModal}
      />
      <ModalCommon
        open={resumoModal}
        setOpenModal={setResumoModal}
        onClose={() => setResumoModal(false)}
      >
        <ModalResumo onClose={() => setResumoModal(false)} />
      </ModalCommon>
    </>
  );
}
